import { Link } from 'react-router-dom';

const InformationSecurity = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Information Security Solutions</h1>
          <p>
            Nexus IT protects your digital estate with layered security architectures, proactive monitoring, and
            governance frameworks tailored to your regulatory environment.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container split">
          <div className="text-block">
            <h2>Secure by Design</h2>
            <p>
              We align security strategy with business priorities, delivering solutions that anticipate advanced threats
              and ensure continuity. Our experts cover architecture, operations, and compliance end-to-end.
            </p>
            <ul className="checklist">
              <li>Cybersecurity assessments and roadmap development</li>
              <li>Identity and access management with adaptive controls</li>
              <li>Network and endpoint protection with threat intelligence</li>
              <li>Incident response planning, drills, and SOC enablement</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>Governance &amp; Compliance</h3>
            <ul>
              <li>Policy and framework development aligned to ISO 27001 and NIST</li>
              <li>Risk management, vendor governance, and data classification programs</li>
              <li>Security awareness, simulations, and executive reporting</li>
              <li>Audit readiness and continuous improvement cycles</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Protection Domains</span>
            <h2 className="section-title">Comprehensive Cyber Defense</h2>
          </div>
          <div className="service-grid">
            <article className="service-card">
              <h3>Perimeter &amp; Network</h3>
              <p>Next-gen firewalls, micro-segmentation, VPN, and secure SD-WAN.</p>
            </article>
            <article className="service-card">
              <h3>Endpoint &amp; Cloud</h3>
              <p>EDR/XDR, CASB, and workload protection for hybrid environments.</p>
            </article>
            <article className="service-card">
              <h3>Data Security</h3>
              <p>DLP, encryption, key management, and data governance controls.</p>
            </article>
            <article className="service-card">
              <h3>Security Operations</h3>
              <p>SIEM/SOAR deployment, SOC staffing, and continuous monitoring.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Advance Your Security Posture</h2>
              <p>Protect your organization with tailored security architectures and governance programs from Nexus IT.</p>
            </div>
            <Link className="btn btn-white" to="/contact">
              Engage Our Team
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default InformationSecurity;
